import axios from "../../axios/ctiConfig";
import ctiRequest from "../../axios/ctiRequests";
import * as actionTypes from "./actionTypes";
import { notify } from "../../helpers/utility";

export const dialLeadStart = () =>{
    return {
        type: actionTypes.MANUAL_LEAD_START,
    }
};


export const dialLeadFail = () =>{
    return {
        type: actionTypes.MANUAL_LEAD_FAIL
    }
}

export const dialLeadSuccess = (leads) =>{
    return {
        type: actionTypes.MANUAL_LEAD_SUCCESS,
        manualLeads: leads,
    }
}

export const manualData = (
agentId,
phoneNo,
) =>{ 
return(dispatch) =>{
    dispatch(dialLeadStart());

    ctiRequest["CTI_MANUAL_DIAL_LEAD_INFO"].agent_id = agentId;
    ctiRequest["CTI_MANUAL_DIAL_LEAD_INFO"].pnone_no = phoneNo;

    axios
    .post("/",ctiRequest["CTI_MANUAL_DIAL_LEAD_INFO"])
    .then((result) =>{
        if (
            result.data.response.status === "SUCCESS" ||
            (result.data.response.status === "FAILURE" &&
              result.data.response.reason === "No Data Availabe.")
          ) {
            dispatch(dialLeadSuccess(result.data.response.leads))
          }
          else{
            dispatch(dialLeadFail(result.data.response.reason))
            notify("Manual Dial Error" + result.data.response.reason, "lead-dial");
          }
    })
    .catch((err) =>{
        dispatch(dialLeadFail(err))
    })
}
}